import { useUnit } from 'effector-react'
import { Button } from 'react-aria-components'

import { cx, sva } from '@portal/styled-system/css'

import { supportIDClicked } from '../model'

export function SupportIDButton({ supportId }: { supportId: string }) {
    const handleSupportIDClick = useUnit(supportIDClicked)
    const classes = supportIDButtonRecipe()
    return (
        <Button className={classes.root} onPress={() => handleSupportIDClick(supportId)}>
            {supportId}&nbsp;
            <i className={cx('fa-regular fa-copy', classes.icon)} />
        </Button>
    )
}

const supportIDButtonRecipe = sva({
    slots: ['root', 'icon'],
    base: {
        root: {
            color: 'gray-v2.800',
            backgroundColor: 'transparent', // reset button
            border: 'none', // reset button
            appearance: 'none', // reset button
            padding: '0',
            borderRadius: 'small',
            '--icon-color': 'colors.gray-v2.600',
            _hover: {
                color: 'primary',
                '--icon-color': 'colors.primary',
            },
            _focusVisible: {
                boxShadow: '[0 0 0 0.2rem var(--shadow-color)]',
                boxShadowColor: 'gray-v2/25',
            },
        },
        icon: { color: '[var(--icon-color)]' },
    },
})
